import * as d3 from 'd3'

export default {

  methods: {

    draw_Donuts() {

      let cir = this.circle
      let title = this.title

      let chart = this.canvasForms
      .append('g')
      .attr('transform', `translate(5, 5)`)

      let cx = cir.front.radius
      this.title.cols.forEach((col,i)=> {
        
        let values = chart
        .append('g')
        .attr('transform', `translate(${cx}, ${0})`)

        this.values.filter(f=> f.visible == 'Y').forEach(d=> {

          values
          .append('text')
          .attr('x', 0).attr('y', d.y)
          .attr('fill', d.tColor).attr('font-size', d.tSize)
          .attr('text-anchor', 'middle')
          .text(this.gmx_numFormat(this.rawData[i][d.code], d.unit))
          .call(this.event_Link, col, i) // event_Link

        })

        // Title
        values
        .append('text')
        .attr('x', 0).attr('y', (cir.front.radius*2) + title.vPad )
        .attr('fill', title.tColor).attr('font-size', title.tSize)
        .attr('text-anchor', 'middle')
        .text(this.title.suffix ? `${col.name} (${this.rawData[i][this.title.suffix]})` : col.name)

        this.draw_Circle(chart, cx, col, this.rawData[i].PROG) // -----> Below
        cx = cx + (cir.space + (cir.front.radius*2))
      })

    },

  } 
}